<qrcode
    id="qrcode"
    [elementType]="'url'"
    [errorCorrectionLevel]="'M'"
    [margin]="0"
    [qrdata]="data()"
    [width]="width()"
/>
